import {
  type Policy,
  PolicyKey,
  PolicyMode,
} from '@kirin/api-client/contracts/policies';

/**
 * Whether the Enforcement Severity Threshold can act on anything, which is
 * when the Settings control is enabled.
 *
 * Real-Time Tool-Call Analysis on Enforce counts too (KIR-5395): its mode is
 * the `toolCallScanMode` setting of Chat & Tool-Call Security, not the policy
 * mode, and the agent gates it on the threshold. The parent policy being Off
 * turns it off, the same as the backend's tool-call mode resolver.
 */
export function hasAnyEnforcePolicy(
  policies: readonly Policy[] | undefined
): boolean {
  return (policies ?? []).some(
    p =>
      p.mode === PolicyMode.Enforce ||
      (p.key === PolicyKey.CursorDatabase &&
        p.mode !== PolicyMode.Off &&
        p.settings?.toolCallScanMode === PolicyMode.Enforce)
  );
}
